/**
 * LocationContext para footerv2 usando @a365/core
 * 
 * Migrado para usar el LocationProvider compartido del core,
 * eliminando código duplicado y mejorando mantenibilidad.
 */

import React from "react";
import { 
  LocationProvider as CoreLocationProvider, 
  useLocation as useCoreLocation
} from "@a365/core";

// Re-exportar para mantener compatibilidad
export const useLocation = useCoreLocation;

// Provider simplificado que usa el del core
export const LocationProvider = ({ children }) => {
  return (
    <CoreLocationProvider>
      {children}
    </CoreLocationProvider>
  );
};
